import { useState } from 'react';
import Input from '@/components/Input';
import Select from '@/components/Select';
import MultiSelect from '@/components/MultiSelect';
import DatePickerModal from '@/components/DatePickerModal';
import type { CustomField } from '../types';

interface CustomFieldPreviewProps {
  field: CustomField;
}

/**
 * カスタムフィールドの入力プレビューコンポーネント
 * フィールドタイプに応じた入力UIをプレビュー表示する
 */
export default function CustomFieldPreview({ field }: CustomFieldPreviewProps) {
  // プレビュー用の日付状態管理
  const [previewDateValue, setPreviewDateValue] = useState('');
  // 短いテキスト
  if (field.field_type === 'short_text') {
    return <Input placeholder="サンプル" className="w-full" />;
  }

  // 長いテキスト
  if (field.field_type === 'long_text') {
    return <Input placeholder="サンプル" className="w-full" />;
  }

  // 数値
  if (field.field_type === 'number') {
    return <Input type="number" placeholder="123" className="w-full" />;
  }

  // 日付・日時
  if (field.field_type === 'date' || field.field_type === 'datetime') {
    return (
      <DatePickerModal
        value={previewDateValue}
        onChange={setPreviewDateValue}
        placeholder={field.field_type === 'date' ? '日付を選択' : '日時を選択'}
        type={field.field_type === 'date' ? 'date' : 'datetime'}
        className="w-full"
      />
    );
  }

  // 単一選択
  if (field.field_type === 'single_select') {
    return (
      <div className="flex h-10 items-center">
        <Select
          items={field.custom_field_options.map((o) => ({ value: o.value, label: o.value }))}
          defaultLabel={
            field.custom_field_options.length > 0
              ? field.custom_field_options[0].value
              : '選択肢未設定'
          }
          className="w-full"
        />
      </div>
    );
  }

  // 複数選択
  if (field.field_type === 'multiple_select') {
    return (
      <div className="w-full">
        <MultiSelect
          options={field.custom_field_options.map((o) => ({ id: o.id, name: o.value }))}
          value={[]}
          onChange={() => {}}
          placeholder={field.custom_field_options.length > 0 ? '選択してください' : '選択肢未設定'}
        />
      </div>
    );
  }

  // 未対応のフィールドタイプ
  return null;
}
